// extracted by mini-css-extract-plugin
export default {"list":"CiVZIsml7z"};